<template>
    <v-scale-transition group hide-on-leave>
        <div class="mr-3" v-if="store.isTimerActive && !store.isTimerExpired">
            Sesion expirara en:
            <v-progress-circular :model-value="store.timerValue" :rotate="360" :size="60" :width="5" color="white">
                {{ store.timeLeft }}
            </v-progress-circular>
        </div>
        <div class="mr-3" v-if="store.isTimerExpired">
            Sesion expirada, por favor refresca la pagina
        </div>
    </v-scale-transition>
    <!-- <v-empty-state v-if="emptyStateStore.active" :icon="emptyStateStore.icon">
        <template v-slot:media>
            <v-icon color="surface-variant"></v-icon>
        </template>

        <template v-slot:title>
            <div class="text-h6">{{ emptyStateStore.title }}</div>
        </template>

        <template v-slot:text>
            <div class="text-medium-emphasis text-caption">
                {{ emptyStateStore.description }}
            </div>
        </template>
    </v-empty-state> -->
</template>
<script setup>
// import { useEmptyStateStore } from '../stores/emptyState'
// import { mapGetters } from "vuex";

import { useAuthStore } from '@/stores/authStore'

const store = useAuthStore();

// export default {
//   data() {
//     return {};
//   },
//   computed: {
//     ...mapGetters(["getEmptyState"]),
//   },
// };
</script>